import React, { useState, createContext } from 'react';

// 사이드 네비게이션 오픈 여부 상태변수
const SideNavContext = createContext({
    isSideNavOpen: false,
    toggleSideNav: () => {},
})

const SideNavProvider = ({children}) => {
    const [isSideNavOpen, setIsSideNavOpen] = useState(false);
    const toggleSideNav = {
        open: () => setIsSideNavOpen(true),
        close: () => setIsSideNavOpen(false),
    };
    const value = { isSideNavOpen, toggleSideNav }
    
    return (
        <SideNavContext.Provider value={value}>
            {children}
        </SideNavContext.Provider>
    );
};

export { SideNavContext, SideNavProvider };
